import React from 'react';
import { connect } from 'react-redux';
import Navigation from '../Components/Navigation';
import { translate } from '../Services/translation';

const NavigationContainer = props => <Navigation {...props} />;

const mapStateToProps = (state, props) => {
  const contentLinks = state.navigation.contentLinks.concat([
    {
      name: translate('language'),
      mobileOnly: true,
      links: [
        { name: 'Swedish (SEK)', url: '/sv/' },
        { name: 'Norwegian (NOK)', url: '/no/' },
        { name: 'Danish (DKK)', url: '/dk/' },
        { name: 'English (GBP)', url: '/en/' },
        { name: 'German (EURO)', url: '/de/' },
        { name: 'Finnish (EURO)', url: '/fi/' },
        { name: 'French (EURO)', url: '/fr/' },
        { name: 'Spanish (EURO)', url: '/es/' },
        { name: 'English (EURO)', url: '/eu/' }
      ],
    },
    {
      name: translate('catalog'),
      url: props.catalogLink,
      mobileOnly: true,
    }
  ]);

  return {
    links: contentLinks,
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NavigationContainer);
